import React from 'react';
import { AnalyticsContext, useAnalyticsEvents } from '@atlaskit/analytics-next';
import { Spotlight, SpotlightTransition } from '@atlaskit/onboarding';
import { useIntl } from '@atlassian/jira-intl';
import { FireScreenAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { fireButtonAnalytics } from '../../common/utils';
import { DISMISS_SPOTLIGHT_BTN } from '../../constants';
import messages from './messages';

const SOURCE_NAME = 'trialPillSpotlight';

export const SpotlightPill = ({ onClose }: { onClose: () => void }) => {
	const { formatMessage } = useIntl();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const handleClose = () => {
		fireButtonAnalytics(createAnalyticsEvent, DISMISS_SPOTLIGHT_BTN, {});
		onClose();
	};

	return (
		<SpotlightTransition>
			<AnalyticsContext data={{ source: SOURCE_NAME }}>
				<Spotlight
					actions={[
						{
							onClick: handleClose,
							text: formatMessage(messages.spotlightDismiss),
						},
					]}
					heading={formatMessage(messages.spotlightHeading)}
					target="edition-awareness-trial-pill"
					key="edition-awareness-trial-pill"
					targetRadius={16}
				>
					{formatMessage(messages.spotlightBody)}
				</Spotlight>
				<FireScreenAnalytics />
			</AnalyticsContext>
		</SpotlightTransition>
	);
};
